// NOT standard shadcn. Retool supplied this from its runtime.
//
// Reconstructed from usage: every one of the 40+ call sites is
// `<Spinner className="h-4 w-4" />` or similar, so the contract is a single
// className prop sizing a spinning indicator that inherits currentColor.
import { cn } from './utils'

export function Spinner({ className, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      role="status"
      aria-label="Loading"
      viewBox="0 0 24 24"
      fill="none"
      className={cn('animate-spin', className)}
      {...props}
    >
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" opacity="0.25" />
      <path
        d="M22 12a10 10 0 0 0-10-10"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  )
}
